var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./visa.j2"] = require( "./visa.j2" );
dependencies["./amex.j2"] = require( "./amex.j2" );
dependencies["./dci.j2"] = require( "./dci.j2" );
dependencies["./disc.j2"] = require( "./disc.j2" );
dependencies["./jcb.j2"] = require( "./jcb.j2" );
dependencies["./mc.j2"] = require( "./mc.j2" );
dependencies["./maestro.j2"] = require( "./maestro.j2" );
dependencies["./cup.j2"] = require( "./cup.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/payment-icons/index.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "payment")),"creditCardDetail")),"cardType")) == "VISA") {
output += "\n\n    ";
env.getTemplate("./visa.j2", false, "core/templates/payment-icons/index.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "payment")),"creditCardDetail")),"cardType")) == "AMEX") {
output += "\n\n    ";
env.getTemplate("./amex.j2", false, "core/templates/payment-icons/index.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "payment")),"creditCardDetail")),"cardType")) == "DCI") {
output += "\n\n    ";
env.getTemplate("./dci.j2", false, "core/templates/payment-icons/index.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "payment")),"creditCardDetail")),"cardType")) == "DISC") {
output += "\n\n    ";
env.getTemplate("./disc.j2", false, "core/templates/payment-icons/index.j2", null, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "payment")),"creditCardDetail")),"cardType")) == "JCB") {
output += "\n\n    ";
env.getTemplate("./jcb.j2", false, "core/templates/payment-icons/index.j2", null, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
t_17.render(context.getVariables(), frame, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
output += t_18
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "payment")),"creditCardDetail")),"cardType")) == "MC") {
output += "\n\n    ";
env.getTemplate("./mc.j2", false, "core/templates/payment-icons/index.j2", null, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_21.render(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
output += t_22
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "payment")),"creditCardDetail")),"cardType")) == "MSTRO") {
output += "\n\n    ";
env.getTemplate("./maestro.j2", false, "core/templates/payment-icons/index.j2", null, function(t_27,t_25) {
if(t_27) { cb(t_27); return; }
t_25.render(context.getVariables(), frame, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
output += t_26
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "payment")),"creditCardDetail")),"cardType")) == "CUP") {
output += "\n\n    ";
env.getTemplate("./cup.j2", false, "core/templates/payment-icons/index.j2", null, function(t_31,t_29) {
if(t_31) { cb(t_31); return; }
t_29.render(context.getVariables(), frame, function(t_32,t_30) {
if(t_32) { cb(t_32); return; }
output += t_30
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"temp")),"creditCardDetail")),"cardType")) == "VISA") {
output += "\n\n    ";
env.getTemplate("./visa.j2", false, "core/templates/payment-icons/index.j2", null, function(t_35,t_33) {
if(t_35) { cb(t_35); return; }
t_33.render(context.getVariables(), frame, function(t_36,t_34) {
if(t_36) { cb(t_36); return; }
output += t_34
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"temp")),"creditCardDetail")),"cardType")) == "AMEX") {
output += "\n\n    ";
env.getTemplate("./amex.j2", false, "core/templates/payment-icons/index.j2", null, function(t_39,t_37) {
if(t_39) { cb(t_39); return; }
t_37.render(context.getVariables(), frame, function(t_40,t_38) {
if(t_40) { cb(t_40); return; }
output += t_38
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"temp")),"creditCardDetail")),"cardType")) == "DCI") {
output += "\n\n    ";
env.getTemplate("./dci.j2", false, "core/templates/payment-icons/index.j2", null, function(t_43,t_41) {
if(t_43) { cb(t_43); return; }
t_41.render(context.getVariables(), frame, function(t_44,t_42) {
if(t_44) { cb(t_44); return; }
output += t_42
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"temp")),"creditCardDetail")),"cardType")) == "DISC") {
output += "\n\n    ";
env.getTemplate("./disc.j2", false, "core/templates/payment-icons/index.j2", null, function(t_47,t_45) {
if(t_47) { cb(t_47); return; }
t_45.render(context.getVariables(), frame, function(t_48,t_46) {
if(t_48) { cb(t_48); return; }
output += t_46
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"temp")),"creditCardDetail")),"cardType")) == "JCB") {
output += "\n\n    ";
env.getTemplate("./jcb.j2", false, "core/templates/payment-icons/index.j2", null, function(t_51,t_49) {
if(t_51) { cb(t_51); return; }
t_49.render(context.getVariables(), frame, function(t_52,t_50) {
if(t_52) { cb(t_52); return; }
output += t_50
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"temp")),"creditCardDetail")),"cardType")) == "MC") {
output += "\n\n    ";
env.getTemplate("./mc.j2", false, "core/templates/payment-icons/index.j2", null, function(t_55,t_53) {
if(t_55) { cb(t_55); return; }
t_53.render(context.getVariables(), frame, function(t_56,t_54) {
if(t_56) { cb(t_56); return; }
output += t_54
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"temp")),"creditCardDetail")),"cardType")) == "MSTRO") {
output += "\n\n    ";
env.getTemplate("./maestro.j2", false, "core/templates/payment-icons/index.j2", null, function(t_59,t_57) {
if(t_59) { cb(t_59); return; }
t_57.render(context.getVariables(), frame, function(t_60,t_58) {
if(t_60) { cb(t_60); return; }
output += t_58
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"temp")),"creditCardDetail")),"cardType")) == "CUP") {
output += "\n\n    ";
env.getTemplate("./cup.j2", false, "core/templates/payment-icons/index.j2", null, function(t_63,t_61) {
if(t_63) { cb(t_63); return; }
t_61.render(context.getVariables(), frame, function(t_64,t_62) {
if(t_64) { cb(t_64); return; }
output += t_62
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"creditCardDetail")),"cardType")) == "VISA") {
output += "\n\n    ";
env.getTemplate("./visa.j2", false, "core/templates/payment-icons/index.j2", null, function(t_67,t_65) {
if(t_67) { cb(t_67); return; }
t_65.render(context.getVariables(), frame, function(t_68,t_66) {
if(t_68) { cb(t_68); return; }
output += t_66
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"creditCardDetail")),"cardType")) == "AMEX") {
output += "\n\n    ";
env.getTemplate("./amex.j2", false, "core/templates/payment-icons/index.j2", null, function(t_71,t_69) {
if(t_71) { cb(t_71); return; }
t_69.render(context.getVariables(), frame, function(t_72,t_70) {
if(t_72) { cb(t_72); return; }
output += t_70
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"creditCardDetail")),"cardType")) == "DCI") {
output += "\n\n    ";
env.getTemplate("./dci.j2", false, "core/templates/payment-icons/index.j2", null, function(t_75,t_73) {
if(t_75) { cb(t_75); return; }
t_73.render(context.getVariables(), frame, function(t_76,t_74) {
if(t_76) { cb(t_76); return; }
output += t_74
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"creditCardDetail")),"cardType")) == "DISC") {
output += "\n\n    ";
env.getTemplate("./disc.j2", false, "core/templates/payment-icons/index.j2", null, function(t_79,t_77) {
if(t_79) { cb(t_79); return; }
t_77.render(context.getVariables(), frame, function(t_80,t_78) {
if(t_80) { cb(t_80); return; }
output += t_78
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"creditCardDetail")),"cardType")) == "JCB") {
output += "\n\n    ";
env.getTemplate("./jcb.j2", false, "core/templates/payment-icons/index.j2", null, function(t_83,t_81) {
if(t_83) { cb(t_83); return; }
t_81.render(context.getVariables(), frame, function(t_84,t_82) {
if(t_84) { cb(t_84); return; }
output += t_82
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"creditCardDetail")),"cardType")) == "MC") {
output += "\n\n    ";
env.getTemplate("./mc.j2", false, "core/templates/payment-icons/index.j2", null, function(t_87,t_85) {
if(t_87) { cb(t_87); return; }
t_85.render(context.getVariables(), frame, function(t_88,t_86) {
if(t_88) { cb(t_88); return; }
output += t_86
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"creditCardDetail")),"cardType")) == "MSTRO") {
output += "\n\n    ";
env.getTemplate("./maestro.j2", false, "core/templates/payment-icons/index.j2", null, function(t_91,t_89) {
if(t_91) { cb(t_91); return; }
t_89.render(context.getVariables(), frame, function(t_92,t_90) {
if(t_92) { cb(t_92); return; }
output += t_90
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"creditCardDetail")),"cardType")) == "CUP") {
output += "\n\n    ";
env.getTemplate("./cup.j2", false, "core/templates/payment-icons/index.j2", null, function(t_95,t_93) {
if(t_95) { cb(t_95); return; }
t_93.render(context.getVariables(), frame, function(t_96,t_94) {
if(t_96) { cb(t_96); return; }
output += t_94
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "payment")),"type")) == "VISA") {
output += "\n\n    ";
env.getTemplate("./visa.j2", false, "core/templates/payment-icons/index.j2", null, function(t_99,t_97) {
if(t_99) { cb(t_99); return; }
t_97.render(context.getVariables(), frame, function(t_100,t_98) {
if(t_100) { cb(t_100); return; }
output += t_98
output += "\n\n";
})});
}
else {
if(env.getFilter("upper").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "payment")),"type")) == "MSTRO") {
output += "\n\n    ";
env.getTemplate("./maestro.j2", false, "core/templates/payment-icons/index.j2", null, function(t_103,t_101) {
if(t_103) { cb(t_103); return; }
t_101.render(context.getVariables(), frame, function(t_104,t_102) {
if(t_104) { cb(t_104); return; }
output += t_102
output += "\n\n";
})});
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/payment-icons/index.j2"] , dependencies)